import { render, staticRenderFns } from "./FormControlCategoriesComponentMenu.vue?vue&type=template&id=0ccea46c"
import script from "./FormControlCategoriesComponentMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlCategoriesComponentMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports